import {
  Segment,
  Button,
  Popup,
  Icon,
  Image,
  SemanticICONS,
  Modal,
  Header,
} from "semantic-ui-react"
import * as React from "react"

type SemanticSIZES =
  | "mini"
  | "tiny"
  | "small"
  | "large"
  | "big"
  | "huge"
  | "massive"
  | undefined

type SemanticPOSITIONS =
  | "bottom right"
  | "bottom center"
  | "bottom left"
  | "left center"
  | "top right"
  | "top center"
  | "top left"
  | "right center"

export interface IPopupTutorial {
  name: string
  icon: SemanticICONS
  image: string
  size?: SemanticSIZES
  position?: SemanticPOSITIONS
}

const Component = (props: IPopupTutorial) => {
  const { name, icon, image, size, position } = props

  return (
    <Segment textAlign="center" vertical={true}>
      <Modal
        className="modal"
        basic
        trigger={
          <Button className="button" basic icon={true} labelPosition="left">
            <Icon name={icon} />
            {name}
          </Button>
        }
      >
        <Modal.Content className="modal-content" image>
          <Image wrapped src={image} />
        </Modal.Content>
      </Modal>
    </Segment>
  )
}

export default Component
